import React, { useState } from "react";
import {
  Lightbulb,
  Cpu,
  Globe,
  Heart,
  Clock,
  Code,
  GraduationCap,
  Users,
  ArrowRight,
  Calendar,
  ExternalLink,
  FileText,
  ArrowUpRight,
  Sparkles,
  Compass,
  Award,
} from "lucide-react";

import logo from "../src/img/mad1.png";
import ImpactCarousel from "./components/ImpactCarousel";
import EventInfo from "./components/EventInfo";
import Objetivos from "./components/Objetivos";
import Actividades from "./components/Actividades";
import { motion } from "framer-motion";
import interfacultades from "../src/img/interfacultades.pdf";
import interuniversidades from "../src/img/interuniversidades.pdf";
import EventoDebateUTPL from "./components/EventoDebateUTPL";
import LegadoPonentes from "./components/LegadoPonentes";

import "./index.css";
import Conferencias from "./components/Conferencias";
import Timeline from "./components/Timeline";
import RecreatedTimeline from "./components/RecreatedTimeline";
import SerMas from "./components/SerMas";
import GuiaLoja from "./components/GuiaLoja";
import AgendaUTPL from "./components/Agenda";
const App = () => {
  const [activeDay, setActiveDay] = useState(1);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Datos extraídos del documento adjunto
  const lines = [
    {
      title: "Innovación en educación a distancia",
      desc: "Presentación de buenas prácticas y proyectos de innovación enfocados a analizar: modelos pedagógicos, metodologías activas, uso de tecnología y experiencias innovadoras en educación en línea.",
      icon: <Lightbulb size={32} />,
    },
    {
      title: "Inclusión y democratización del acceso a la educación superior",
      desc: "Socialización de experiencias que promuevan el acceso a la educación para poblaciones diversas y territorios alejados.",
      icon: <Cpu size={32} />,
    },
    {
      title: "Impacto social de la educación a distancia",
      desc: "Presentación de experiencias sobre el impacto de la modalidad a distancia y en línea en el desarrollo personal, profesional y comunitario de los Alumni UTPL.",
      icon: <Globe size={32} />,
    },
    {
      title: "Emprendimiento e innovación estudiantil",
      desc: "Fortalecimiento de la competencia emprendedora para estudiantes y docentes por medio de su participación en proyectos que impulsen la creatividad, el emprendimiento y la generación de soluciones para los retos de la educación en línea.",
      icon: <Heart size={32} />,
    },
  ];
  const days = [
    { id: 1, label: "Día 1: 3 de septiembre " },
    { id: 2, label: "Día 2: 4 de septiembre" },
  ];

  const agenda = {
    1: [
      {
        time: "08:30 - 18:00",
        event: "Zonas interactivas",
      },
      {
        time: "08:30 - 18:00",
        event: "Summer Camp de Emprendimiento e Innovación UTPL",
      },
      {
        time: "08:30 - 09:00",
        event: "Registro",
        type: "Acceso",
      },
      {
        time: "09:00 - 09:30",
        event: "Acto inaugural edificio 10 ",

        type: "Inauguración",
      },
      {
        time: "09:30 - 10:30",
        type: "Conferencia magistral",
        speaker: "Ricardo Dueñas - CEO de Grupo Ekos",
        event:
          " La Universidad que transforma del conocimiento al talento, del talento a la empresa y de la empresa al desarrollo",
        type: "Conferencia",
      },

      {
        time: "10:30 - 10:45",
        type: "Intervención ",
        event: "Santiago Acosta Aide, Rector UTPL",
      },

      {
        time: "10:45 - 12:00",
        event:
          "Recorrido por las instalaciones del edificio 10. Zonas interactivas: recorrido tecnológico. Coffee break",
        type: "Experiencia",
      },
      {
        time: "12:00 - 15:00",
        event: "Almuerzo libre",
        type: "Networking",
      },

      {
        time: "15:00 - 15:15",
        event: "Ph. D. Cristina Díaz de la Cruz, Vicerrectora Académica",

        type: " Interveción Inaugural",
      },
      {
        time: "15:15 - 16:00",
        event: "Conferencia magistral: El futuro de la educación",
        speaker:
          "Ph. D. Albert Sangrà Morer, Catedrático Universidad Oberta de Catalunya",
        moderator: "Dr. Artieres Romeiro",
        type: "Conferencia",
      },
      {
        time: "16:00 - 18:00",
        event: "Innova Docentes Interfacultades - Interuniversidades",
        type: "Innovación",
      },
      {
        time: "20:00 - 21:00",
        event:
          'Obra de teatro: Viajeros en el tiempo "Historia de los 50 años de la MAD UTPL"',
        place: "Lugar: Teatro Simón Bolívar - Rocafuerte y Olmedo",
        type: "Cultural",
      },
    ],

    2: [
       {
        time: "08:30 - 18:00",
        event: "Zonas interactivas",
      },
      {
        time: "08:30 - 18:00",
        event: "Summer Camp de Emprendimiento e Innovación UTPL",
      },
      
      {
        time: "08:00 - 09:00",
        event: "Eucaristía de Acción de Gracias",

        type: "Eucaristía",
         place: "Lugar: Capilla UTPL",
      },
    
      {
        time: "10:00 - 10:30",
        event: "Coffee break",
        type: "Networking",
      },
      {
        time: "10:30 - 13:00",
        event: "Innova Docentes Interfacultades - Interuniversidades",
        type: "Innovación",
      },
      {
        time: "08:00 - 18:00", // Unificado según la indicación de jornada partida (08:00 a 13:00 - 14:00 a 18:00)
        event: "Zonas interactivas: recorrido tecnológico",
        type: "Experiencia",
      },
      {
        time: "13:00 - 14:30",
        event: "Almuerzo libre",
        type: "Networking",
      },
      {
        time: "14:30 - 15:30",
        event:
          'Legado que trasciende: "Historias que inspiran, huellas que perduran"',
        type: "Historias",
      },
      {
        time: "15:30 - 16:30",
        event: '"Ser +", historias que trascienden fronteras',
        type: "Historias",
      },
      {
        time: "16:30 - 17:30",
        event: " 50 años ofertando MAD: transformando vidas y contextos",
        type: "Debate",
      },
      {
        time: "17:30 - 18:00",
        event: "Premiación y cierre",
        type: "Cierre",
      },
      {
        time: "18:00 - 22:00",
        event: "Noche cultural: UTPL Fest",
        type: "Cultural",
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header / Nav */}

      {/* Hero */}
      <section id="inicio" className="relative pt-10 pb-24 overflow-hidden">
        <div className="hero-shape"></div>
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <motion.img
                src={logo}
                alt="utpl"
                className="h-auto w-40 mb-4"
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              />
            </div>
            <h1 className="text-6xl md:text-6xl  font-bold text-[#004270] leading-[0.95] tracking-tight">
              Innovación que{" "}
              <span className="text-[#febe10] font-black md:text-7xl">
                conecta
              </span>
              , educación que{" "}
              <span className="text-[#febe10] font-black md:text-7xl">
                transforma.
              </span>
            </h1>
            <p>
              El congreso conmemora los 50 años de educación a distancia de la
              UTPL, un encuentro para rediseñar el futuro de la educación
              superior en Latinoamérica.
            </p>
          </div>

          <div className="relative  ">
            <ImpactCarousel></ImpactCarousel>
          </div>
        </div>
      </section>
      <div className="pb-24">
        <EventInfo></EventInfo>
      </div>
      <section
        id="inscribete"
        className="bg-gray-50 py-24 px-6 sm:px-6 lg:px-8 font-sans"
      >
        <div className="max-w-5xl mx-auto">
          {/* Encabezado de la sección */}
          <div className="text-center mb-12">
            <h2>Inscríbete ahora</h2>
            <p>Selecciona tu categoría y asegura tu cupo en el evento.</p>
          </div>

          {/* Contenedor de Tarjetas */}
          <div className="grid md:grid-cols-2 gap-8 items-stretch">
            {/* Tarjeta: Comunidad UTPL */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 flex flex-col justify-between relative overflow-hidden transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center justify-between mb-6">
                  <span className="p-3 bg-blue-50 text-blue-600 rounded-xl">
                    <GraduationCap className="h-6 w-6" />
                  </span>
                  <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
                    Interno
                  </span>
                </div>

                <h3>Comunidad UTPL</h3>
                <p>
                  Docentes, administrativos, estudiantes continuos y UTPL
                  Alumni.
                </p>

                <div className="flex items-baseline mb-8">
                  <span className="text-4xl font-extrabold text-gray-900">
                    Sin costo
                  </span>
                </div>
              </div>

              <div>
                {/* Botón Estado: Próximamente */}

                <a
                  href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=qknrbm1D5kO-zbvfeeUHfXQqUup4lq5DkK8ZMnAo__pUMDBKNTVMSUM0SE0wVklQOThZUk9KUTNWQi4u&route=shorturl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-amber-50  border-amber-200 text-amber-800   rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-sm font-semibold shadow-sm transition-colors duration-200 group"
                >
                  <span>Inscríbete ahora</span>
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              </div>
            </div>

            {/* Tarjeta: Participantes Externos */}
            <div className="bg-white rounded-2xl border-2 border-blue-600 shadow-xl p-8 flex flex-col justify-between relative overflow-hidden transition-all duration-300 hover:scale-[1.01]">
              {/* Tag destacado */}
              <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl uppercase tracking-wider">
                Abiertas
              </div>

              <div>
                <div className="flex items-center justify-between mb-6">
                  <span className="p-3 bg-blue-50 text-blue-600 rounded-xl">
                    <Users className="h-6 w-6" />
                  </span>
                  <span className="bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
                    Público General
                  </span>
                </div>

                <h3>Participantes Externos</h3>
                <p>
                  Profesionales, graduados de otras instituciones y público en
                  general.
                </p>

                <div className="flex items-baseline mb-8">
                  <span className="text-sm font-semibold text-gray-500 mr-1">
                    USD
                  </span>
                  <span className="text-5xl font-extrabold text-gray-900">
                    50
                  </span>
                </div>
              </div>

              <div>
                {/* Botón de Pago / Registro */}
                <a
                  href="https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIk1BRDAiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTU4Iiwibm9tYnJlQ3Vyc28iOiAiQ09OR1JFU08gNTAgQcORT1MgTUFEIiwic29icmVwYXNhckN1cG9zIjogIk4ifQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-sm font-semibold shadow-sm transition-colors duration-200 group"
                >
                  <span>Registrarse y Pagar</span>
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="objetivos">
        <Objetivos></Objetivos>
      </section>

      <section id="actividades">
        <Actividades></Actividades>
        {/* Stats */}
      </section>

      {/* Lines */}
      <section id="lineas" className="py-32 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-end justify-between mb-10 gap-8">
            <div className="max-w-2xl space-y-4">
              <h2>Líneas temáticas</h2>
              <p>Ejes centrales de debate y aprendizaje colaborativo.</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {lines.map((line, i) => (
              <div
                key={i}
                className="line-card bg-white p-4 rounded-[2.5rem] flex flex-col items-center text-center"
              >
                <div className="w-16 h-16 bg-[#004270]/5 text-[#004270] rounded-2xl flex items-center justify-center mb-8">
                  {line.icon}
                </div>
                <h4>{line.title}</h4>
                <p>{line.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <RecreatedTimeline></RecreatedTimeline>

      <section className="bg-slate-50 py-24 px-6 sm:px-6 lg:px-8 font-sans ">
        <div className="max-w-6xl mx-auto">
          {/* Encabezado Principal */}
          <div className="text-center mb-16">
            <h2>Innova Docentes</h2>
            <p>
              Experiencias innovadoras desarrolladas por docentes y estudiantes
              en educación en línea.
            </p>
          </div>

          {/* Contenedor de Convocatorias */}
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            {/* Convocatoria 1: Inter Universitarios */}
            <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8 flex flex-col justify-between transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="p-3 bg-gray-200 text-[#004270] rounded-xl shadow-sm">
                    <Globe className="h-6 w-6" />
                  </span>
                  <div>
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Convocatoria Nacional
                    </span>
                    <h3>Inter Universitarios</h3>
                  </div>
                </div>

                <p>
                  Busca contribuir a la mejora de los procesos de
                  enseñanza-aprendizaje mediante la incorporación de
                  metodologías activas, tecnologías educativas, estrategias de
                  evaluación, inclusión, interdisciplinariedad, sostenibilidad y
                  evidencias de impacto académico.
                </p>

                <div className="mt-10 bg-white rounded-xl p-4 border border-gray-100  ">
                  <p>
                    <b>Dirigido a: </b>
                  </p>
                  <p>
                    Docentes que cuenten con experiencias implementadas y
                    documentadas, cuyos resultados puedan ser compartidos como
                    referentes de innovación educativa para la comunidad
                    académica nacional.
                  </p>
                </div>
              </div>
              <a
                className="my-10"
                href={interuniversidades}
                target="_blank"
                rel="noopener noreferrer"
              >
                📄 Bases de la Convocatoria
              </a>
            </div>

            {/* Convocatoria 2: Inter Facultades - Personal UTPL */}
            <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8 flex flex-col justify-between transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="p-3 bg-gray-200 text-[#004270] rounded-xl shadow-sm">
                    <GraduationCap className="h-6 w-6" />
                  </span>
                  <div>
                 

                    <h3>Inter Facultades</h3>
                  </div>
                </div>

                <p>
                  Busca reconocer, visibilizar y proyectar las experiencias de
                  innovación educativa desarrolladas por docentes de las
                  diferentes facultades, carreras y departamentos académicos de
                  la universidad.
                </p>

                <div className="mt-10 bg-white rounded-xl p-4 border border-gray-100  ">
                  <p>
                    <b> Dirigido a:</b>
                  </p>
                  <p>
                    <b> Personal docente de la UTPL </b>(de todas las
                    facultades, modalidades y centros) que lidere o colabore en
                    prácticas transformadoras dentro del ecosistema
                    institucional.
                  </p>
                </div>
              </div>
              <a
                href={interfacultades}
                target="_blank"
                rel="noopener noreferrer"
              >
                📄 Bases de la Convocatoria
              </a>
           
            </div>
          </div>
        </div>
      </section>

      <Conferencias></Conferencias>

      <SerMas></SerMas>
      <LegadoPonentes></LegadoPonentes>

      <EventoDebateUTPL></EventoDebateUTPL>

      <AgendaUTPL></AgendaUTPL>
 
      <section id="loja">
        <GuiaLoja></GuiaLoja>
      </section>

      {/* Featured Block */}
    </div>
  );
};

export default App;
